import ButtonControl from '../button-control'
import Panel from '../panel'
import CategorySelector from './CategorySelector'
import AuthorSelector from './AuthorSelector'
import ArticlesOverviewFilterPill from './ArticlesOverviewFilterPill'
import PublicLabelSelector from './PublicLabelSelector'

const ArticlesOverviewFilters = ({ categories, publicLabels, authors, filters, onFilterChange, onClearFilterCriteria }) => {
  let appliedFilters = []
  Object.keys(filters).forEach(key => filters[key].length && appliedFilters.push(filters[key][0]))
  return (
    <div>
      <Panel>
        <div class='articles-overview__filters-container'>
          <CategorySelector
            categories={categories}
            selected={filters.category[0] && filters.category[0].name}
            onFilterChange={(e) => onFilterChange('category', [{ id: e.target.getAttribute('value'), name: e.target.textContent, type: 'category' }])}
          />
          <PublicLabelSelector
            publicLabels={publicLabels}
            selected={filters.publicLabel[0] && filters.publicLabel[0].name}
            onFilterChange={(e) => onFilterChange('publicLabel', [{ id: e.target.getAttribute('value'), name: e.target.getAttribute('value'), type: 'publicLabel' }])}
          />
          <AuthorSelector
            authors={authors}
            selected={filters.author[0] && filters.author[0].name}
            onFilterChange={(e) => onFilterChange('author', [{ id: e.target.getAttribute('value'), name: e.target.textContent, type: 'author' }])}
          />
        </div>
      </Panel>
      {
        appliedFilters.length
          ? <div class={'articles-overview__filter-pill-container'}>
            { appliedFilters.map(filter => <ArticlesOverviewFilterPill filter={filter} onClose={() => onFilterChange(filter.type, [])} />) }
            <ButtonControl
              class='articles-overview__filters-clear'
              title='Clear selection'
              variant='warning'
              onClick={onClearFilterCriteria}
            />
          </div> : null
      }
    </div>
  )
}

export default ArticlesOverviewFilters
